import { ComponentImageSphere } from '../component.constants';
import { ImageViewFill } from '../image/image-static-preview';
import { ImageContainer } from '../image/image.style';
import { computePaddingTop } from '../shared/component-height/component-dimension.utils';
import {
  ComponentHeightWrapper,
  ComponentInnerWrapper,
} from '../shared/component-height/component-dimensions.style';
import ImageSphereTag from './image-sphere-tag';

const ImageSphereStaticPreview = ({
  properties: { printImageUrls, dimensionData },
}: Omit<ComponentImageSphere, '__typename'>) => {
  return (
    <ComponentHeightWrapper
      style={{
        paddingTop: `${computePaddingTop(dimensionData)}%`,
      }}
    >
      <ComponentInnerWrapper>
        <ImageContainer $fullBorderRadius>
          <ImageViewFill imageUrls={printImageUrls || []} />
        </ImageContainer>
        <ImageSphereTag />
      </ComponentInnerWrapper>
    </ComponentHeightWrapper>
  );
};

export default ImageSphereStaticPreview;
